import React, { memo } from "react";
import { formatDateSeparator } from "../../utils/formatters";
import "./DateSeparator.css";

/**
 * Separador de data entre mensagens
 */
const DateSeparator = memo(({ date }) => {
  return (
    <div className="sc-date-separator">
      <span className="sc-date-separator__text">
        {formatDateSeparator(date)}
      </span>
    </div>
  );
});

DateSeparator.displayName = "DateSeparator";

export default DateSeparator;
